export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7309.120a4386.jpg";